import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Block, Section } from '../../types/section.type';
import { COMPONENT_MAPPING } from '../../data/component-map.data';
import { ExperimentalPendingTasks as PendingTasks } from '@angular/core';

@Component({
    selector: 'app-sb-block',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './sb-block.component.html',
    styleUrl: './sb-block.component.scss',
})
export class SbBlockComponent {
    /**
     * Block
     */
    @Input() section!: Section;

    /**
     * Block
     */
    @Input() block!: Block;

    // Store loaded components
    loadedComponents: { [key: string]: any } = {};

    private pendingTasks = inject(PendingTasks);

    async ngOnInit() {
        // Preload components that are used in this block
        await this.preloadComponents();
    }

    private async preloadComponents() {
        //  Add this pending task at the start
        const taskId = this.pendingTasks.add();
        const componentPromises = this.block.children?.map(async (child) => {
            if (COMPONENT_MAPPING[child.component]) {
                try {
                    this.loadedComponents[child.component] = await COMPONENT_MAPPING[child.component]();
                } catch (error) {
                    console.error(`Failed to load component: ${child.component}`, error);
                }
            }
        });

        await Promise.all(componentPromises as any);
        taskId();
    }

    getComponent(componentKey: string) {
        return this.loadedComponents[componentKey] || null;
    }
}
